import { render, staticRenderFns } from "./Shck.vue?vue&type=template&id=46d6646e&scoped=true&"
import script from "./Shck.vue?vue&type=script&lang=js&"
export * from "./Shck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d6646e",
  null
  
)

export default component.exports